import React from "react";
import AlphaherdSectionContentCard from "../../component/shared/card/alphaherd.sectionContentCard";
import AlphaherdSectionImgCard from "../../component/shared/card/alphaherd.sectionImgCard";
import { heroSectionData } from "./data";

const AlphaherdHeroSection = () => {
  return (
    <section className="alpha_hero_section">
      <div className="section_overly"></div>
      <div className="container">
        <div className="section_wrapper">
          <div className="row">
            {heroSectionData.map((d, i) => (
              <>
                <div className="col-md-6 section_content">
                  <AlphaherdSectionContentCard
                    title={d.title}
                    description={d.description}
                    buttonText={d.button}
                    counter={d.counter}
                  />
                </div>
                <div className="col-md-6 section_img">
                  <AlphaherdSectionImgCard animDir="zoom-in" img={d.image} />
                </div>
              </>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default AlphaherdHeroSection;
